<template>
	<!-- Slider main container -->
	<div class="swiper">
		<!-- Additional required wrapper -->
		<div class="swiper-wrapper">
			<transition-group name="list-complete" tag="div" class="list-wrap">
				<div v-for="(item, index) in list" :key="item.index" class="swiper-slide list-complete-item">
					<div style="display: flex;justify-content: space-between;">
						<div class="top">{{ "TOP" + item.index }}</div>
						<div style="width: 300px;line-height: 40px;">{{ item.name }}</div>
						<div style="line-height: 40px;color: #11E9F0;">{{ item.value }}</div>
					</div>					
					<el-progress :percentage="(item.value/max) * 100" :show-text="false" :stroke-width="2"
						define-back-color="#495969">
					</el-progress>
				</div>
			</transition-group>
		</div>
	</div>
</template>

<script>
	export default {
		name: "swiper-list",
		data() {
			return {
				list: [],
				max: 0
			};
		},
		props: {
			data: {
				type: Array,
				default: () => [],
			},
			// 根据选择器来变换标题
			year: {
				type: String,
				default: () => "",
			},
		},
		watch: {
			data(e) {
				// console.log(e)
				this.list = e.map((i, index) => {
					return { ...i,
						index: index + 1
					};
				});
				if (this.list && this.list.length != 0) {
					this.max = this.list.reduce((a, b)=> {
						return a.value > b.value ? a : b
					}).value
				}				
			}
		},
		mounted() {
			this.timer = setInterval(() => {
				let arr = [...this.list];
				arr.push(arr[0]);
				arr.shift(arr);
				this.list = arr;
			}, 3000);
		},
		methods: {
			onSwiper() {},
			onSlideChange() {},
		},
	};
</script>

<style scoped>
	.swiper {
		width: 420px;
		margin: 0 auto;
	}

	.list-item {
		/*display: inline-block;*/
		margin-right: 10px;
	}

	.list-complete-item {
		transition: all 0.2s ease;
		height: 40px;		
		font-size: 15px;
		position: relative;
		margin-top: 10px;
		width: 420px;
		/* border-bottom: 2px solid #495969; */
	}

	.list-complete-enter,
	.list-complete-leave-to

	/* .list-complete-leave-active for below version 2.1.8 */
		{
		opacity: 0;
	}

	.list-complete-leave-active {
		position: absolute;
		opacity: 0;
	}

	.list-wrap {
		height: 210px;
		overflow: hidden;
	}
	
	.top {
		width: 56px;
		height: 28px;
		background: linear-gradient(180deg, #0F1F40 0%, #2B4881 100%);
		box-shadow: inset 0px 5px 15px 1px rgba(33,216,211,0.16);
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		border: 1px solid #5A94FF;
		text-align: center;
		line-height: 28px;
		margin-top: 5px;
	}
</style>
<style>
	.el-progress-bar__inner {
		background: linear-gradient(90deg, #453FE7 0%, #1EE3DD 100%);
	}
</style>